import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  cartDecrement,
  cartIncrement,
  removeFromCart,
} from "../../redux/cart/actions";
import {
  productDecrement,
  productIncrement,
  productRemoved,
} from "../../redux/product/actions";

export default function CartItem({ product, cartItems }) {
  const { id, imgUrl, productName, category, price, stock } = product;
  const quantity = cartItems.filter((item) => item.id === id)[0].quantity;
  const dispatch = useDispatch();
  const [canIncrement, setCanIncrement] = useState(true);
  const [canDecrement, setCanDecrement] = useState(false);

  const handlePlusClick = () => {
    dispatch(cartIncrement(id));
    dispatch(productDecrement(id));
  };

  const handleMinusClick = () => {
    dispatch(cartDecrement(id));
    dispatch(productIncrement(id));
  };

  useEffect(() => {
    if (quantity < stock) {
      setCanIncrement(true);
    } else {
      setCanIncrement(false);
    }
    if (quantity > 1) {
      setCanDecrement(true);
    }
    if (quantity < 2) {
      setCanDecrement(false);
    }
  }, [quantity, stock]);

  const handleDeleteClick = () => {
    dispatch(removeFromCart(id));
    dispatch(productRemoved(id));
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        <img className="lws-cartImage" src={imgUrl} alt="product" />

        <div className="space-y-2">
          <h4 className="lws-cartName">{productName}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            disabled={!canIncrement}
            onClick={handlePlusClick}
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{quantity}</span>
          <button
            className="lws-decrementQuantity"
            disabled={!canDecrement}
            onClick={handleMinusClick}
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>
        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{price * quantity}</span>
        </p>
      </div>
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button className="lws-removeFromCart" onClick={handleDeleteClick}>
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
}
